//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: check-mark.svg
//
import React from 'react';
import cs from 'classnames';
export function CheckMarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", {
    className: cs('Icon', 'Icon--check-mark', props.className),
    style: props.style,
    "aria-hidden": props.title ? undefined : true,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props.title && /*#__PURE__*/React.createElement("title", null, props.title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.365 34.538a2 2 0 10-2.73 2.924l15 14a2 2 0 002.847-.119l29-32a2 2 0 10-2.964-2.686L24.881 47.153 11.365 34.538z"
  }));
}